import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const EMPTY_FORM = { current: "", next: "", confirm: "" };
const MIN_PASSWORD = 6;

// Caixa "Mudar a minha password" do separador Utilizadores
export default function ChangePasswordBox({ apiUrl, getAuthHeader, onAuthError }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);

  const setField = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.current || !form.next) {
      toast.error("Preenche a password atual e a nova.");
      return;
    }
    if (form.next.length < MIN_PASSWORD) {
      toast.error("A password nova deve ter pelo menos 6 caracteres.");
      return;
    }
    if (form.next !== form.confirm) {
      toast.error("A confirmação não é igual à password nova.");
      return;
    }

    setSaving(true);
    try {
      const response = await fetch(`${apiUrl}/api/admin/change-password`, {
        method: "POST",
        headers: { Authorization: getAuthHeader(), "Content-Type": "application/json" },
        body: JSON.stringify({ current_password: form.current, new_password: form.next }),
      });
      if (response.status === 401) {
        onAuthError();
        return;
      }
      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        toast.success(data.message || "Password alterada.");
        setForm(EMPTY_FORM);
      } else {
        toast.error(data.detail || "Erro ao alterar a password.");
      }
    } catch (error) {
      toast.error("Erro de ligação.");
    } finally {
      setSaving(false);
    }
  };

  const inputClass = "flex-1 bg-[#141414] border border-[#3A3A3A] rounded px-3 py-2 text-[#F5F5F5] text-sm";

  return (
    <form onSubmit={handleSubmit} className="bg-[#1F1F1F] border border-[#3A3A3A] rounded p-4 mb-6 max-w-2xl">
      <h3 className="text-[#F5F5F5] font-semibold mb-3 flex items-center gap-2">
        <KeyRound size={18} className="text-[#A6C48A]" /> Mudar a minha password
      </h3>
      <div className="flex flex-col sm:flex-row gap-3">
        <input type="password" autoComplete="current-password" value={form.current} onChange={setField("current")} placeholder="Password atual" className={inputClass} />
        <input type="password" autoComplete="new-password" value={form.next} onChange={setField("next")} placeholder="Nova (mín. 6)" className={inputClass} />
        <input type="password" autoComplete="new-password" value={form.confirm} onChange={setField("confirm")} placeholder="Repetir a nova" className={inputClass} />
        <button
          type="submit"
          disabled={saving}
          className="bg-[#A6C48A] hover:bg-[#B9D3A1] disabled:opacity-50 text-[#010000] font-bold px-4 py-2 rounded"
        >
          {saving ? "A guardar…" : "Mudar"}
        </button>
      </div>
    </form>
  );
}
